export default "__VITE_ASSET__6ekPfz5D__"